import React from 'react'
import PropTypes from 'prop-types'
import resolveProps from '../../utils/resolveProps'

const config = {
  types: [
    {
      title: 'highlight',
      isDefault: true
    },
    'feedback',
    'hat',
    'reverse',
    'category',
    'medium',
    'inverse'
  ],
  modifiers: [
    //mdn-Tag--default
    {
      title: 'default',
      isDefault: true
    },
    'inverse',
    'medium'

  ],
  states: []
}

export default function Tag(props) {
  const {
    highlight,
    feedback,
    hat,
    category,
    reverse,
    medium,
    inverse,
    children,
    ...rest
  } = props
  return (
    <div {...rest} className={resolveProps(props, config, 'Tag')}>
      {(feedback && !reverse) && (
        <span className="mdn-Tag-icon mdn-Icon-informacoes mdn-Icon--sm" />
      )}
      <p>{children}</p>
      {(feedback && reverse) && (
        <span className="mdn-Tag-icon mdn-Icon-informacoes mdn-Icon--sm" />
      )}
    </div>
  )
}

Tag.propTypes = {
  feedback: PropTypes.bool,
  highlight: PropTypes.bool,
  children: PropTypes.node,
  hat: PropTypes.bool,
  category: PropTypes.bool,
  inverse: PropTypes.bool,
  reverse: PropTypes.bool,
  medium: PropTypes.bool,
  etc: PropTypes.object
}
